const AuthBackground = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%", height: "100%" }}
      preserveAspectRatio="none"
      viewBox="0 0 1076 1080"
      fill="none"
    >
      <path
        d="M861.003 263.953C776.161 149.506 856.668 40.2982 907.527 0H0V1081H824.986C764.122 1049.94 702.024 941.77 940.543 757.607C1238.69 527.403 967.057 407.012 861.003 263.953Z"
        fill="url(#paint0_linear_20_4)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20_4"
          x1="-73.5"
          y1="517"
          x2="1076"
          y2="510.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD966" />
          <stop offset="0.464259" stopColor="#FFA9C7" />
          <stop offset="1" stopColor="#B87CFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AuthBackground;
